import {AnyAction} from 'redux';

import {
    FINDER_OVERVIEW_INITIALIZE,
    FINDER_OVERVIEW_SET_SCHEMA,
    FINDER_OVERVIEW_SET_ITEMTYPENAME,
    FINDER_OVERVIEW_SET_ADVANCED_SEARCH_OPTIONS
} from '../../constants';

import User from '~/shared/src/model/User';

import {AdditionalGlobalState} from '~/frontend/src/store';
import {
    ComponentProps as FinderOverviewComponentProps
} from '~/frontend/src/modules/panels/Finder/overview';
import {
    initialize
} from '~/frontend/src/components/base/ItemFinder/overview/utilities';

type FinderOverviewComponentPropsRequired = Required<FinderOverviewComponentProps>;
type FinderOverviewComponentPropsMutable = {
    -readonly [K in keyof FinderOverviewComponentProps] : FinderOverviewComponentProps[ K ]
}

const relevantActions = [
    FINDER_OVERVIEW_INITIALIZE,
    FINDER_OVERVIEW_SET_SCHEMA,
    FINDER_OVERVIEW_SET_ITEMTYPENAME,
    FINDER_OVERVIEW_SET_ADVANCED_SEARCH_OPTIONS
];

export default function finderReducer( state : FinderOverviewComponentPropsRequired = {} as FinderOverviewComponentPropsRequired, action : AnyAction, additionalGlobalState : AdditionalGlobalState ) : FinderOverviewComponentPropsMutable {
    let outState : FinderOverviewComponentPropsMutable = state,
        schema,
        status,
        timestamp,
        timezone,
        itemTypeName;

    // create new state object (nested objects are kept)
    if ( relevantActions.includes( action.type ) ) {

        // copy current (stay immutable!)
        outState = {
            ...outState
        } as FinderOverviewComponentPropsMutable;

        switch ( action.type ) {

            case FINDER_OVERVIEW_INITIALIZE:

                // initialize
                outState = {
                    ...outState,
                    ...initialize( {
                        ...outState,
                        user: additionalGlobalState.user
                    } as FinderOverviewComponentProps & { user : User } )
                };

                break;

            case FINDER_OVERVIEW_SET_SCHEMA:
                ( { schema } = action );

                outState.schema = schema;

                // reset to defaults
                delete outState.status;
                delete outState.timezone;
                delete outState.timestamp;

                delete outState.itemTypeName;
                delete outState.searchString;
                delete outState.columns;
                delete outState.filters;
                delete outState.sorters;
                delete outState.page;
                delete outState.search;

                // initialize
                outState = {
                    ...outState,
                    ...initialize( {
                        ...outState,
                        user: additionalGlobalState.user
                    } as FinderOverviewComponentProps & { user : User } )
                };

                break;

            case FINDER_OVERVIEW_SET_ITEMTYPENAME:
                ( { itemTypeName } = action );

                outState.itemTypeName = itemTypeName;

                // reset to defaults
                delete outState.status;
                delete outState.timezone;
                delete outState.timestamp;

                delete outState.searchString;
                delete outState.columns;
                delete outState.filters;
                delete outState.sorters;
                delete outState.page;
                delete outState.search;

                // initialize
                outState = {
                    ...outState,
                    ...initialize( {
                        ...outState,
                        user: additionalGlobalState.user
                    } as FinderOverviewComponentProps & { user : User } )
                };

                break;

            case FINDER_OVERVIEW_SET_ADVANCED_SEARCH_OPTIONS:
                ( { status, timestamp, timezone } = action );

                outState.status = status;
                outState.timestamp = timestamp;
                outState.timezone = timezone;

                delete outState.columns;
                delete outState.filters;
                delete outState.sorters;
                delete outState.page;
                delete outState.search;

                // initialize
                outState = {
                    ...outState,
                    ...initialize( {
                        ...outState,
                        user: additionalGlobalState.user
                    } as FinderOverviewComponentProps & { user : User } )
                };

                // preserve
                outState.status = status;
                outState.timestamp = timestamp;
                outState.timezone = timezone;

                break;
        }
    }

    return outState;
}
